import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteCommunity, getCommunitiesAndCategorys } from '../../../actions/userActions'
import ListZonesView from '../../containers/Zone/ListZones/ListZones'

const ListZones = () => {
    const {communitysAndCategorys} = useSelector(state=>state.userInfo)
    const dispatch = useDispatch()
    const [search, setSearch] = useState("")
    useEffect(() => {
      dispatch(getCommunitiesAndCategorys(search))
    
      return () => {
        
      }
    }, [search])
const deleteZone = (id,close)=>{
    dispatch(deleteCommunity(id,close))
}
  return (
    <ListZonesView zones={communitysAndCategorys} deleteZone={deleteZone}/>
  )
}

export default ListZones